var _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5174_128319",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88437 1.11624C3.37253 1.60439 3.37253 2.39585 2.88437 2.88401C2.39622 3.37216 1.60476 3.37216 1.1166 2.88401C0.62845 2.39585 0.62845 1.60439 1.1166 1.11624C1.60476 0.628083 2.39622 0.628083 2.88437 1.11624Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88437 1.11624C3.37253 1.60439 3.37253 2.39585 2.88437 2.88401C2.39622 3.37216 1.60476 3.37216 1.1166 2.88401C0.62845 2.39585 0.62845 1.60439 1.1166 1.11624C1.60476 0.628083 2.39622 0.628083 2.88437 1.11624Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46011 1.5405C2.71395 1.79434 2.71395 2.2059 2.46011 2.45974L3.30864 3.30827C4.03111 2.5858 4.03111 1.41444 3.30864 0.691974L2.46011 1.5405ZM2.46011 2.45974C2.20627 2.71358 1.79471 2.71358 1.54087 2.45974L0.69234 3.30827C1.41481 4.03074 2.58617 4.03074 3.30864 3.30827L2.46011 2.45974ZM1.54087 2.45974C1.28703 2.2059 1.28703 1.79434 1.54087 1.5405L0.69234 0.691974C-0.030129 1.41444 -0.030129 2.5858 0.69234 3.30827L1.54087 2.45974ZM1.54087 1.5405C1.79471 1.28666 2.20627 1.28666 2.46011 1.5405L3.30864 0.691974C2.58617 -0.0304953 1.41481 -0.0304953 0.69234 0.691974L1.54087 1.5405Z",
    fill: "black",
    fillOpacity: 0.8,
    mask: "url(#path-1-inside-1_5174_128319)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88437 5.61624C3.37253 6.10439 3.37253 6.89585 2.88437 7.38401C2.39622 7.87216 1.60476 7.87216 1.1166 7.38401C0.62845 6.89585 0.62845 6.10439 1.1166 5.61624C1.60476 5.12808 2.39622 5.12808 2.88437 5.61624Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88437 10.1162C3.37253 10.6044 3.37253 11.3959 2.88437 11.884C2.39622 12.3722 1.60476 12.3722 1.1166 11.884C0.62845 11.3959 0.62845 10.6044 1.1166 10.1162C1.60476 9.62808 2.39622 9.62808 2.88437 10.1162Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalEllipsis);
export default __webpack_public_path__ + "static/media/vertical-ellipsis.eae00957.svg";
export { ForwardRef as ReactComponent };